import classnames from 'classnames/bind'
import React from 'react'

import { ArticleItemProps } from '~/components/ArticleItem'
import ArticleLine from '~/components/ArticleLine'
import RichText, { RichTextBlock } from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface ArticlePushProps {
  className?: string
  title?: RichTextBlock[]
  items?: ArticleItemProps[]
}
/**
 * Article push slice
 * @param props
 * @returns Slice
 */
function ArticlePush({ className, title, items }: ArticlePushProps) {
  const titleStyle = useStyle({ textPreset: 'title-content-section' })
  const gridStyle = useStyle({ grid: 'base-grid' })

  return (
    <section className={cx(css.ArticlePush, className)}>
      <div className={cx(gridStyle, css.title)}>
        {title && (
          <RichText
            className={cx(titleStyle, css.titleContent)}
            render={title}
          />
        )}
      </div>
      {items?.length > 0 && <ArticleLine items={items} />}
    </section>
  )
}

ArticlePush.defaultProps = {}

export default ArticlePush
